import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "static-body bg-gondola" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "ch-toolbar" }
const _hoisted_4 = { class: "ch-cats" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "ch-loading"
}
const _hoisted_7 = {
  key: 1,
  class: "ch-empty"
}
const _hoisted_8 = {
  key: 2,
  class: "ch-grid"
}
const _hoisted_9 = { class: "ch-logo-wrap" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = {
  key: 1,
  class: "ch-logo-placeholder"
}
const _hoisted_12 = { class: "ch-info" }
const _hoisted_13 = { class: "ch-name" }
const _hoisted_14 = { class: "ch-meta" }
const _hoisted_15 = {
  key: 0,
  class: "ch-badge"
}
const _hoisted_16 = {
  key: 1,
  class: "ch-country"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarTwo = _resolveComponent("NavbarTwo")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NavbarTwo),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "static-hero" }, [
      _createElementVNode("div", { class: "container mw-1356" }, [
        _createElementVNode("span", { class: "top-title" }, "CHANNELS"),
        _createElementVNode("h1", null, "Our Channel Lineup"),
        _createElementVNode("p", null, "Browse our full library of live TV channels")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            type: "text",
            class: "ch-search",
            placeholder: "Search channels..."
          }, null, 512), [
            [_vModelText, _ctx.search]
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
              return (_openBlock(), _createElementBlock("button", {
                key: cat,
                class: _normalizeClass(["ch-cat-btn", { active: _ctx.activeCategory === cat }]),
                onClick: ($event: any) => (_ctx.activeCategory = cat)
              }, _toDisplayString(cat), 11, _hoisted_5))
            }), 128))
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "ch-spinner" }, null, -1),
              _createTextVNode(" Loading channels... ")
            ])))
          : (!_ctx.filtered.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ti ti-device-tv-off" }, null, -1)),
                _createElementVNode("p", null, "No channels found" + _toDisplayString(_ctx.search ? ' for "' + _ctx.search + '"' : '') + ".", 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtered, (ch) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: ch.id,
                    class: "ch-card"
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      (ch.logo_url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: ch.logo_url,
                            alt: ch.name,
                            class: "ch-logo"
                          }, null, 8, _hoisted_10))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[3] || (_cache[3] = [
                            _createElementVNode("i", { class: "ti ti-device-tv" }, null, -1)
                          ])))
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(ch.name), 1),
                      _createElementVNode("div", _hoisted_14, [
                        (ch.category)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(ch.category), 1))
                          : _createCommentVNode("", true),
                        (ch.country)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(ch.country), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ]))
      ])
    ]),
    _createVNode(_component_MainFooter),
    _createVNode(_component_CopyRight)
  ]))
}